import Cookies from "js-cookie";

const isValidUser = () => {
  const token = Cookies.get("jweToken");
  return !!token;
};

export { isValidUser };
